import { appRouterPaths } from "@/services/navigation";
import { CheckStatusPage } from "@/pages/RegistrationPage/Components/CheckStatus";
import type { RouteProps } from "react-router-dom";

export const checkStatusPageRoute: RouteProps = {
  path: appRouterPaths.checkStatus,
  element: <CheckStatusPage />,
};
